var CONSTANTS = require('frontend-controller/lib/constants');
const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'relationship',
	],

	config: {
		preventAllFieldLabels: false
	},

	model: {
		initDate: false
	},

	methods: {
		prepare: function(){
			var self = this;
			if(!self.model.activityYear){
				self.model.activityYear = ((self.getResourceRegisterContent('relation') || {}).activityYear || 0) * 1;
			}
			if(!self.model.initDate){
				if(self.model.activityYear != new Date().getFullYear()){
					self.model.initDate = utils.moment(self.model.activityYear + '-01-01T00:00:00.000').format()
				}
			}

			if(self.model.initDate){
				for(var f in self.model.fields){
					if(self.model.fields[f].fieldCode === 'date'){
						self.model.fields[f].config.initDate = self.model.initDate;
					}
				}
			}
		},

		/**
		 * update separators used to distinct the different elements (primaryKeys of sub-tables)
		 */
		updateAvailableSeparators: function(){
			var self = this;
			var d, attributes, primaryKey;
			self.config.availableSeparators.list = {};

			var data = self.resourceData.data || [];
			for(d in data){
				attributes = data[d].attributes || {};
				primaryKey = attributes[data[d].primaryKey || 'id'];

				if(primaryKey){
					self.config.availableSeparators.list['separator_' + String(primaryKey)] = {
						key: 		primaryKey,
						title: 		attributes.title || '',
						resource:  	attributes
					};
				}
			}
		},

		updateRelationshipElement: function(elementHeadOptions, data, separatorResourceIndex, actionExtension){
			if(this.config.activityType){
				utils.refMerge(actionExtension, {
					source: {
						load: {
							componentData: {
								model: {
									dirtyFields: {
										data: {
											attributes: {
												type: this.config.activityType
											}
										}
									}
								},
							},
						},
					},
				})
			}
		},
	}
}
